function initVideoFeature() {
	document.querySelectorAll(".video_feature-layout").forEach((layout) => {
		const dialog = layout.querySelector(".video-dialog");
		if (!dialog || dialog.dataset.videoInit) return;
		dialog.dataset.videoInit = "true";

		const frame = dialog.querySelector(".video-dialog-frame");
		let opener = null;

		const close = () => dialog.close();

		layout.querySelectorAll("[data-video-open]").forEach((button) => {
			button.addEventListener("click", () => {
				opener = button.getAttribute("tabindex") === "-1" ? layout.querySelector(".pk-button[data-video-open]") : button;
				const iframe = document.createElement("iframe");
				iframe.src = dialog.dataset.videoSrc;
				iframe.title = dialog.getAttribute("aria-label") || "";
				iframe.allow = "autoplay; fullscreen; picture-in-picture";
				iframe.allowFullscreen = true;
				frame.replaceChildren(iframe);
				dialog.showModal();
			});
		});

		dialog.querySelector("[data-video-close]")?.addEventListener("click", close);
		dialog.addEventListener("click", (event) => event.target === dialog && close());
		dialog.addEventListener("close", () => {
			frame.replaceChildren();
			opener?.focus();
		});
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initVideoFeature);
} else {
	initVideoFeature();
}
